/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */

export { run } from "@oclif/core";
// Exported for use in config files.
export type { AssertTaggingPackageConfig } from "./commands/generate/assertTags.js";
export type {
	AssertTaggingConfig,
	BumpConfig,
	FlubConfig,
	PackageNamePolicyConfig,
	PackageRequirements,
	PolicyConfig,
	PreviousVersionStyle,
	ReleaseNotesConfig,
	ReleaseNotesSection,
	ReleaseNotesSectionName,
	ReleaseReportConfig,
	ScriptRequirement,
} from "./config.js";
export type { knownReleaseGroups, ReleaseGroup, ReleasePackage } from "./releaseGroups.js";
